import { type ScreenDefinitionAttributes } from './generated/ScreenDefinitionAttributes';
import ApplicationModel, { attr } from '../ApplicationModel';
import { model } from '../modelBuilder';

interface ScreenDefinition extends ScreenDefinitionAttributes {}

@model
class ScreenDefinition extends ApplicationModel {
  // Start auto-generated
  static typename: 'ScreenDefinition' = 'ScreenDefinition';
  get typename(): 'ScreenDefinition' {
    return 'ScreenDefinition';
  }

  static internalTypename: 'ScreenDefinition' = 'ScreenDefinition';
  get internalTypename(): 'ScreenDefinition' {
    return 'ScreenDefinition';
  }

  static fields = {
    id: attr({ readable: true }),
    screenableType: attr({ readable: true }),
    permissions: attr.belongsTo({
      readable: true,
      typename: 'ResourcePermissions',
    }),
    customFieldDefinitions: attr.hasMany({ readable: true }),
    screenDefinitionControls: attr.hasMany({
      args: { filters: 'ScreenDefinitionControlFilters' },
      readable: true,
    }),
  };
  // End auto-generated
}

export default ScreenDefinition;
